import React, { forwardRef, PropsWithChildren } from 'react';
import { ButtonProps } from './Button.types';
import { Spin } from 'antd';
import { ButtonBase } from './Button.ui';
import { css } from 'styled-components';
import { Flex } from '../layout';

export const Button = forwardRef<
  HTMLButtonElement,
  PropsWithChildren<ButtonProps>
>(
  (
    {
      loading,
      disabled,
      type = 'button',
      shape = 'default',
      onClick,
      testid,
      children,
      variant = 'primary',
      kind = 'normal',
      ...restProps
    },
    ref
  ) => {
    return (
      <ButtonBase
        disabled={disabled || loading}
        data-testid={testid}
        onClick={onClick}
        type={type}
        kind={kind}
        variant={variant}
        shape={shape}
        ref={ref}
        {...restProps}
      >
        {loading && (
          <Flex mr="10px">
            <Spin
              tip={null}
              css={css`
                display: flex;
                span i.ant-spin-dot-item {
                  background-color: white;
                }
              `}
            />
          </Flex>
        )}
        {children}
      </ButtonBase>
    );
  }
);

Button.displayName = 'Button';

export default Button;
